import { SupportedGames } from "@/types/game";
import {
  getTcgPlayerCardName as getTcgPlayerCardNameUA,
  getUAIdFromTcgPlayerId,
} from "@/lib/games/unionArena/getCardDataLocal";
import { getTcgPlayerCardName as getTcgPlayerCardNameRB } from "@/lib/games/riftbound/getCardDataLocal";
import { getOpId, getRbId } from "@/lib/tcgplayer/getCardPrice";
import opTcgPlayerMapping from "@/lib/tcgplayer/opid_to_tcgplayerid.m.json";
import { getCardImgproxyUrl } from "@/lib/imgproxy";
import { tcgplayerImageUrl } from "@/lib/cdn";

export function getIdFromTCGPlayerId(
  game: SupportedGames,
  tcgplayerId: string,
) {
  if (game === "one-piece") {
    return getOpId(tcgplayerId);
  } else if (game === "union-arena") {
    return getUAIdFromTcgPlayerId(tcgplayerId);
  } else if (game === "riftbound") {
    return getRbId(tcgplayerId);
  } else if (game === "palworld") {
    // Palworld: Look up card by tcgplayer_id
    const { getGameHandler } = require("@/games");
    const gameHandler = getGameHandler("palworld");
    const { cleanCardData } = gameHandler.getDeckBuilderCardFunctions();
    const allCards = Object.values(cleanCardData() as Record<string, any>);
    const card = allCards.find((c: any) => c.tcgplayer_id === tcgplayerId);
    return card?.id as string | undefined;
  } else {
    throw new Error(
      `getIdFromTCGPlayerId: Game "${game}" is not implemented. ` +
        `Please add a case for this game in lib/tcgplayer/tcgplayer_helper.ts`,
    );
  }
}

function getTcgPlayerCardNameOP(tcgplayerId: string): string | undefined {
  const mapping = opTcgPlayerMapping as Record<
    string,
    Record<string, Array<{ productId: number; name: string }>>
  >;

  for (const setData of Object.values(mapping)) {
    for (const cardVariants of Object.values(setData)) {
      const variant = cardVariants.find(
        (v) => v.productId.toString() === tcgplayerId,
      );
      if (variant) {
        return variant.name;
      }
    }
  }
  return undefined;
}

export function getTcgPlayerCardName(
  game: SupportedGames,
  tcgplayerId: string | null,
) {
  if (!tcgplayerId) {
    return undefined;
  }
  if (game === "union-arena") {
    return getTcgPlayerCardNameUA(tcgplayerId);
  } else if (game === "one-piece") {
    return getTcgPlayerCardNameOP(tcgplayerId);
  } else if (game === "riftbound") {
    return getTcgPlayerCardNameRB(tcgplayerId);
  } else if (game === "palworld") {
    // Palworld: Look up card name by tcgplayer_id
    const { getGameHandler } = require("@/games");
    const gameHandler = getGameHandler("palworld");
    const { cleanCardData } = gameHandler.getDeckBuilderCardFunctions();
    const allCards = Object.values(cleanCardData() as Record<string, any>);
    const card = allCards.find((c: any) => c.tcgplayer_id === tcgplayerId);
    return card?.name as string | undefined;
  } else {
    throw new Error(
      `getTcgPlayerCardName: Game "${game}" is not implemented. ` +
        `Please add a case for this game in lib/tcgplayer/tcgplayer_helper.ts`,
    );
  }
}

export function getTCGPlayerCardImage(
  id: string,
  size: "original" | "316x440" | "158x220" | "90x125" = "original",
) {
  return getCardImgproxyUrl(tcgplayerImageUrl(id), size);
}
